import React, { createContext, useEffect, useState } from "react";
import { AgentImportProviderProps, AgentImportValue } from "./types";

export const AgentImportContext = createContext<AgentImportValue | undefined>(
  undefined
);

export function AgentImportProvider({
  children,
  interopUrl,
}: Readonly<AgentImportProviderProps>) {
  const [agentImport, setAgentImport] = useState<AgentImportValue | undefined>(
    undefined
  );

  useEffect(() => {
    if (interopUrl) {
      import(
        /* webpackIgnore: true */ `${interopUrl}/agent/main.bundle.js`
      ).then((agent) => {
        setAgentImport({
          module: agent,
          interopUrl,
        });
      });
    }
  }, [interopUrl]);

  return (
    <AgentImportContext.Provider value={agentImport}>
      {children}
    </AgentImportContext.Provider>
  );
}
